module.exports = {"sld:ColorMapEntry":[{"quantity":-999,"color":"#FFFFFF","label":"NO DATA"},{"quantity":0,"color":"#D7D7D7","label":"0"},{"quantity":0.001,"color":"#198CDB","label":"<=0.015"},{"quantity":0.03,"color":"#91E3AD","label":"0.015-0.13"},{"quantity":0.06,"color":"#DEFFB0","label":"0.13-0.44"},{"quantity":0.1,"color":"#FFE68C","label":"0.44-0.95"},{"quantity":9,"color":"#FF9982","label":"0.95-1.9"},{"quantity":12,"color":"#FF4D30","label":">1.9"}]}


//////////////////
// WEBPACK FOOTER
// ./static/bunSld_cropRisks/county_maize_wheat_rice_mme_1981_2016_lcr_70_maize.json
// module id = YBHa
// module chunks = 171